import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { trackingSearchSchema } from '@/entities/tracking';
import { DispatchPage } from '@/pages/dispatch';

export const Route = createFileRoute('/tracking')({
  staticData: { permission: 'dispatch.view' },
  validateSearch: trackingSearchSchema,
  component: TrackingRoute,
});
function TrackingRoute() {
  const params = Route.useSearch();
  const navigate = useNavigate({ from: '/tracking' });
  return (
    <DispatchPage
      params={params}
      onParamsChange={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }), replace: true })
      }
    />
  );
}
